import { TBreakpointsKeys, breakpoints } from './constants';

const getCurrentBreakpoint = (viewportWidth: number) => {
  const filteredBreakpoints = Object.keys(breakpoints).filter(
    (key) =>
      viewportWidth >
      Number(breakpoints[key as TBreakpointsKeys].replace('px', ''))
  );

  return filteredBreakpoints[filteredBreakpoints.length - 1];
};

export default getCurrentBreakpoint;
